export default __webpack_public_path__ + "static/IMR_Commercial-87069f5904c30bc5e55eb19788ecbc27.png";